import React, { useState, useEffect, type ReactNode } from "react";
import { LoaderContext } from "./LoaderContext";
import { setLoaderSetter } from "./loaderController";

interface LoaderProviderProps {
  children: ReactNode;
}

export const LoaderProvider: React.FC<LoaderProviderProps> = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setLoaderSetter(setIsLoading); // подключаем глобальный контроллер
  }, []);

  return (
    <LoaderContext.Provider value={{ isLoading, setIsLoading }}>
      {children}
    </LoaderContext.Provider>
  );
};
